import classNames from 'classnames';
import { BodyS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/prepaidLoyalty/servicesTabStyle';
import VatClause from 'components/VatClause/VatClause';

// @ts-ignore
const useStyles = makeStyles(styles);

const VatClauseWrapper = () => {
	const classes = useStyles();
	return (
		<div className={classNames([classes.vatClauseWrapper])}>
			<VatClause type="one-line" />
			<div className={classes.termsAndConditionsWrapper}>
				<BodyS color="disabled-light">{`${translate('prepaid.loyalty.terms')} ${translate(
					'prepaid.loyalty.terms.conditions'
				)}`}</BodyS>
			</div>
		</div>
	);
};

export default VatClauseWrapper;
